import { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Renders its children directly in <body>. Needed for modals opened from inside
 * another modal: the DS modal containers use `transform`, which makes a nested
 * `position: fixed` modal fit inside the parent instead of the whole screen.
 */
export const BodyPortal: React.FC<{ children: ReactNode }> = ({ children }) =>
    typeof document === "undefined" ? <>{children}</> : createPortal(children, document.body);

export default BodyPortal;
